import { render, staticRenderFns } from "./HistoryItemTypeMenu.vue?vue&type=template&id=15ec43ca&scoped=true&"
import script from "./HistoryItemTypeMenu.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeMenu.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeMenu.vue?vue&type=style&index=0&id=15ec43ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec43ca",
  null
  
)

export default component.exports